import Vue from '../../vue';

const createDirective = eventName => ({
  inserted: (el, binding) => {
    const onClickCallback = binding.value;
    window.removeEventListener(eventName, onClickCallback);
    window.addEventListener(eventName, onClickCallback)
    console.log('BINDED')
  },
  unbind: (el, binding) => {
    console.log('UNBINDED')
    window.removeEventListener(eventName, binding.value);
  },
})

Vue.directive('window-click', createDirective('click'));
Vue.directive('window-mousedown', createDirective('mousedown'));
Vue.directive('window-mouseup', createDirective('mouseup'));